import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  FormControl
} from 'react-bootstrap'
import {
  BoardModalView,
  ViewBody
} from 'components/Sidebar'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import KanBoIcon from 'components/KanBoIcon'
import Sortable from 'components/Sortable'
import Label from './Label'
import AddLabel from './AddLabel'
import { withBoardPermission } from 'dataProviders/Board'
import {
  ModalBoardContext,
} from 'components/Modal'

export const labelDragType = 'LABEL'

export class Labels extends React.Component {
  static propTypes = {
    boardContext: PropTypes.object.isRequired,

    leftSidebar: PropTypes.object.isRequired,

    permission: PropTypes.object.isRequired,

    labels: PropTypes.array.isRequired,

    requestPositionLabel: PropTypes.func.isRequired,
  }

  state = {
    query: ''
  }

  handleAddClick = () => {
    this.props.leftSidebar.push(() =>
      <ModalBoardContext boardId={this.props.boardContext.id}>
        <AddLabel />
      </ModalBoardContext>
    )
  }

  handleLabelPositionChange = ({ itemId, position }) => {
    this.props.requestPositionLabel({
      boardId: this.props.boardContext.id,
      id: itemId,
      position
    })
  }

  handleSearchChange = (event) => {
    this.setState({
      query: event.target.value
    })
  }

  render () {
    const {
      permission,
      labels
    } = this.props
    const {
      query
    } = this.state

    const filteredLabels =
      (
        query
          ? labels.filter(label => label.name.toLowerCase().indexOf(query.toLowerCase()) !== -1)
          : labels
      ).map(label => label.id)

    return (
      <BoardModalView
        title={<FormattedMessage id='LABELS' />}
        buttons={permission.owner ? [{
          icon: <KanBoIcon name='kanbo-16-plus' />,
          title: <FormattedMessage id='ADD' />,
          onClick: this.handleAddClick
        }] : undefined}
      >
        <ViewBody className='m-b-10'>
          <FormattedMessage id='SEARCH_PLACEHOLDER'>
            {formattedMessage =>
              <FormControl
                type='text'
                placeholder={formattedMessage}
                onChange={this.handleSearchChange}
              />
            }
          </FormattedMessage>
        </ViewBody>
        {filteredLabels.length > 0 ? (
          <Sortable
            vertical
            containerTag='ul'
            className='list-group'
            name='labels'
            dragType={labelDragType}
            component={Label}
            items={filteredLabels}
            droppable={permission.owner}
            onPositionChange={this.handleLabelPositionChange}
          />
        ) : (
          <ViewBody>
            <FormattedMessage id='NOTHING_TO_SHOW' />
          </ViewBody>
        )}
      </BoardModalView>
    )
  }
}

export default withLeftSidebar(withBoardPermission(Labels))
